import React, { useMemo, useState } from "react";
import * as S from "./ChatbotGuideSelector.style"
import { useTranslation } from "react-i18next";
import * as P from "../../../../../../../../utils/pipes";
import { QUERY_GET_PROCESS_NAMES, QUERY_GET_PROCESS_TYPES_BY_ID } from "../../../../../../../../graphql/queries/Process";
import { useQuery } from "@apollo/client";
import FlorenzButton from "../../../../../../../florenzComponents/florenzButton";
import FlorenzSelect from "../../../../../../../florenzComponents/florenzSelect";

function ChatbotGuideSelector({
  selectedProcess,
  selectProcess,
  selectedPartition,
  selectPartition,
  // processTypes,
  closeFunc,
  isNavigationModule
}) {

  const {t, i18n: { language }} = useTranslation("global"); 
  const [selectedProcessTemp, setSelectedProcessTemp] = useState(null);
  const [selectedPartitionTemp, setSelectedPartitionTemp] = useState(null);

  const { data: processData } = useQuery( QUERY_GET_PROCESS_NAMES );  

  const { data: processTypes, error } = useQuery(
      QUERY_GET_PROCESS_TYPES_BY_ID, 
      { variables: 
        { 
          processId: [selectedProcessTemp?.id],
          technology: "openai" 
        } 
      }
    );
    
  const processTypesOptionsFiltered = useMemo(() => {    
    const listToMap = isNavigationModule 
      ? processTypes?.process[0]?.processGuides.filter((guide) => guide.isNavigationModule) 
      : processTypes?.process[0]?.processGuides.filter((guide) => !guide.isNavigationModule)

    return listToMap;
  }, [processTypes, isNavigationModule])

  const processTypesOptions = useMemo(() => {        
    const list = processTypesOptionsFiltered?.map((partition) => {
      return {
        value: partition.id,
        text: partition.displayName
      };
    });

    return list ? list : [];
  }, [processTypes]);

  const processList = useMemo(() => {
    const list = isNavigationModule
      ? processData?.process?.filter((item) => item.id !== 45 && item.id !== 16 && item.processGuides.filter((guide) => guide.isNavigationModule)?.length > 0) 
      : processData?.process?.filter((item) => item.id !== 45 && item.id !== 16 && item.processGuides.filter((guide) => !guide.isNavigationModule)?.length > 0) 
    return list  
  }, [processData, isNavigationModule])
  

  const disabledChatbot = () => {
    return !(selectedProcessTemp && processTypesOptionsFiltered?.length > 0)
  }

  const processSelection = (processId) => {
    setSelectedProcessTemp(processData?.process.find(process => process.id === processId))
  }

  const partitionSelection = (partitionId) => {    
    setSelectedPartitionTemp(processTypesOptions.find(partition => partition.value === partitionId))
  }


  const selectOptions = () => {
   selectProcess(selectedProcessTemp)
   selectPartition(selectedPartitionTemp) 
  }

  console.log("twin peaks", processData);
  

  return (
    <S.ChatbotGuideSelector>
      <div className="header">
        {t("chatbotAI.guidelines.selectMedicalGuide")}
      </div>
      <div className="selectors">
        <div className="process-selects">
          <div className="process-selects__select">
            <FlorenzSelect
              placeholder={t("globally.allPrograms")}
              label={t("chatbotAI.processToConsult")}
              required={true}
              items={
                processList?.map(
                  process => {
                    return {
                      value: process.id,
                      text: P.dataTranslation(process.processName, language)
                    }
                  }
                ) || []
              }
              value={selectedProcessTemp?.id}
              setValue={(e) => {
                processSelection(e)
                setSelectedPartitionTemp(null)
              }}
              heightList={"200px"}
            />                        
          </div>
          <div className="process-selects__select">
            <FlorenzSelect
              placeholder={t("chatbotAI.guidelines.allPartitions")}
              label={t("chatbotAI.guidelineToConsult")}
              required={true}
              items={processTypesOptions}
              value={selectedPartitionTemp?.value}
              setValue={(e) => partitionSelection(e)}
              heightList={"200px"}
              disabled={disabledChatbot()}
            />  
          </div>
        </div>
      </div>
      <div className="footer">
        <div className="button-cancel">
          <FlorenzButton
            size={"s"}
            text={t("globally.cancel")}
            typeStyle={"secondaryWhite"}
            onClick={closeFunc}
          />
        </div>
        <div className="button-select">
          <FlorenzButton
            size={"s"}
            text={t("globally.select")}
            typeStyle={"primary"}
            disabled={
              !selectedPartitionTemp
            }
            icon={  
              !selectedPartitionTemp && "zaia-i-lock-chat"
            }
            onClick={() => {
              selectOptions()
              closeFunc()
            }}
          />
        </div>
      </div>
    </S.ChatbotGuideSelector>
  );
  

}

export default ChatbotGuideSelector;
